import React from "react";
import { Wordmark } from "../Wordmark";
import { SITE } from "../../config/site";
import { NewsletterForm } from "../NewsletterForm";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative pt-20 pb-10" style={{ backgroundColor: "#0E0A16", borderTop: "1px solid #2A2233" }}>
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16">
          <div className="md:col-span-7">
            <Wordmark className="h-7" testid="footer-wordmark" />

            <div className="mt-10 max-w-[520px]">
              <div className="text-[11px] uppercase tracking-[0.3em] mb-3" style={{ color: "#9B8FAC" }}>Newsletter</div>
              <p className="text-sm leading-relaxed mb-4 max-w-[46ch]" style={{ color: "#9B8FAC" }}>
                New drops, new artists, and first access when we open the doors wider.
              </p>
              <NewsletterForm source="footer" layout="inline" testidPrefix="newsletter-footer" />
            </div>
          </div>

          <div className="md:col-span-3 md:col-start-9">
            <div className="text-[11px] uppercase tracking-[0.3em] mb-5" style={{ color: "#9B8FAC" }}>Legal</div>
            <ul className="space-y-3 text-base mb-10">
              <li><a data-testid="footer-terms" href="/terms" className="hover:text-[#C724B1] transition-colors duration-300" style={{ color: "#F4EEF7" }}>Terms of Service</a></li>
              <li><a data-testid="footer-privacy" href="/privacy" className="hover:text-[#C724B1] transition-colors duration-300" style={{ color: "#F4EEF7" }}>Privacy Notice</a></li>
            </ul>
            <div className="text-[11px] uppercase tracking-[0.3em] mb-5" style={{ color: "#9B8FAC" }}>Connect</div>
            <ul className="space-y-3 text-base">
              <li><a data-testid="footer-instagram" href={SITE.instagram} target="_blank" rel="noopener noreferrer" className="hover:text-[#C724B1] transition-colors duration-300" style={{ color: "#F4EEF7" }}>Instagram {SITE.instagramHandle}</a></li>
              <li><a data-testid="footer-contact" href="/contact" className="hover:text-[#C724B1] transition-colors duration-300" style={{ color: "#F4EEF7" }}>Contact</a></li>
              <li><a data-testid="footer-email" href={`mailto:${SITE.email}`} className="hover:text-[#C724B1] transition-colors duration-300" style={{ color: "#F4EEF7" }}>{SITE.email}</a></li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8" style={{ borderTop: "1px solid #2A2233" }}>
          <p className="text-xs" style={{ color: "#9B8FAC" }}>
            {SITE.legalName} ({SITE.jurisdiction}), {SITE.city} · VYNLWORLD&trade;
          </p>
          <p className="text-xs" style={{ color: "#9B8FAC" }}>
            © {new Date().getFullYear()} {SITE.legalName}. Powered by Stripe &amp; Printful.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
